import {
  ApiErrorCatalog,
  DUPLICATED_TEMPLATE_NAME_MESSAGE,
  ResolveApiErrorProps,
} from '../core/api-error';
import { Failure } from '../core/failure';

export enum TemplatesRepositoryFailureTypes {
  failToComunicateWithTheServer,
  duplicatedName,
}

export class TemplatesRepositoryFailure extends Failure<TemplatesRepositoryFailureTypes, void> {
  private constructor(errorMessage: string, errorType: TemplatesRepositoryFailureTypes) {
    super(errorMessage, errorType, undefined);
  }

  public static fromApiError(props: ResolveApiErrorProps) {
    return new TemplatesRepositoryFailure(
      ApiErrorCatalog.resolveMessage(props),
      TemplatesRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static failToComunicateWithTheServer() {
    return new TemplatesRepositoryFailure(
      'Falha ao acessar os templates',
      TemplatesRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static duplicatedName(message?: string) {
    return new TemplatesRepositoryFailure(
      message?.trim() || DUPLICATED_TEMPLATE_NAME_MESSAGE,
      TemplatesRepositoryFailureTypes.duplicatedName
    );
  }
}
